<div>
    <div class="breadcrumbs">
      <button class="back-button" (click)="navigateToDashboard()">
          <mat-icon>arrow_back_ios</mat-icon>
          <span class="breadcrumb-text">{{ breadcrumbTextHome }}</span>
      </button>
      <span class="breadcrumb-text">{{ breadcrumbTextFacilityConfig }}</span>
  </div>
<content-panel>
  <panel-header heading="{{ panelHeading }}">
    <div class="edit-icon">
      <button mat-button (click)="onEdit()" class="edit-button">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </panel-header>

  <panel-body>
    @if (!hasConfiguration) {
      <div class="new-config-text">{{ emptyZoneText }}</div>
    } @else {
      <div class="facility-display-container">
        @for (zone of facilityDisplayData; track facilityDisplayData) {
          <mat-accordion>
            <mat-expansion-panel
              (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
              expanded="true"
            >
              <mat-expansion-panel-header>
                <mat-panel-title class="panel-title">
                  <div class="zone-title">{{ zone.Name }}</div>
                  <div class="item-count">
                    {{ formatItemCount(zone.Stations) }}
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (station of zone.Stations; track station) {
                <div class="station-container">
                  <div class="station-name">
                    {{ station.Name }}
                  </div>
                  <div class="item-count">
                    ({{ station.InspectionTasks.length }} items)
                  </div>
                </div>
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    }
  </panel-body>
</content-panel>
